class SearcherryConfig {
  public cssPaths: string[] = []
  public siteSearchInputSelectors: string[] = ['.search']
  public apiUrl: string = ''
  public categoryPageSize: number = 18
  public oldSearchLink: string = ''
  public widgetMode: string = 'full'
  public widgetStyle: string = 'flat'
  public badgeDiscountMode: string = 'none'
  public userColor: string = ''
  public showProductSku: boolean = false
  public initSearchPhraseTip: string = ''
  public isSearchRowFixed: boolean = false
  public isAnimationEnabled: boolean = true

  public load (config: any) {
    if (config.cssPaths && config.cssPaths.length > 0) {
      this.cssPaths = config.cssPaths
    }

    if (config.siteSearchInputSelectors && config.siteSearchInputSelectors.length > 0) {
      this.siteSearchInputSelectors = []
      let selectors = config.siteSearchInputSelectors.split(',')
      for (let key in selectors) {
        let selector = selectors[key].trim()
        switch (selector.substring(0, 1)) {
          case '.':
          case '#':
            this.siteSearchInputSelectors.push(selector)
            break

          default:
          // console.error('Wrong selector for search input: ' + selector)
        }
      }
    }

    if (config.apiUrl && config.apiUrl.length > 0) {
      this.apiUrl = config.apiUrl
    }

    if (config.categoryPageSize && config.categoryPageSize > 0) {
      this.categoryPageSize = config.categoryPageSize
    }

    if (config.showOldSearchLink === true && config.oldSearchLink && config.oldSearchLink.length > 0) {
      this.oldSearchLink = config.oldSearchLink
    }

    if (config.widgetMode && config.widgetMode.length > 0) {
      this.widgetMode = config.widgetMode
    }

    if (config.widgetStyle && config.widgetStyle.length > 0) {
      this.widgetStyle = config.widgetStyle
    }

    if (config.badgeDiscountMode && config.badgeDiscountMode.length > 0) {
      this.badgeDiscountMode = config.badgeDiscountMode
    }

    if (config.userColor && config.userColor.length > 0) {
      this.userColor = config.userColor
    }

    if (config.hasOwnProperty('showProductSku')) {
      this.showProductSku = config.showProductSku !== false // false, только если явно указано
    }

    if (config.hasOwnProperty('isSearchRowFixed')) {
      this.isSearchRowFixed = config.isSearchRowFixed !== false // false, только если явно указано
    }

    if (config.initSearchPhraseTip && config.initSearchPhraseTip.length > 0) {
      this.initSearchPhraseTip = config.initSearchPhraseTip
    }

    if (config.hasOwnProperty('isAnimationEnabled')) {
      this.isAnimationEnabled = config.isAnimationEnabled !== false // false, только если явно указано
    }
  }

  public getInsertToDomElement (): Element | null {
    return document.body
  }
}

const searcherryConfig = new SearcherryConfig()

export default searcherryConfig
